
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/player/[id]",
      function () {
        return require("private-next-pages/[country]/[language]/player/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[country]/[language]/player/[id]"])
      });
    }
  